import React, { useState, useEffect } from "react";
import { Card, DatePicker } from "antd";
import { PiDotsThreeBold } from "react-icons/pi";
import Chart from "react-apexcharts";
import { Row, Col } from "react-bootstrap";
import { IoPersonOutline } from "react-icons/io5";
import { GoStack } from "react-icons/go";
import { GrTransaction } from "react-icons/gr";

const WeeklyChartBusiness = () => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "bar",
      toolbar: { show: true },
    },
    plotOptions: {
      bar: {
        columnWidth: "60%",
        dataLabels: { position: "top" },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}`,
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    xaxis: {
      categories: [],
      position: "bottom",
      labels: { style: { fontSize: "12px" } },
      axisBorder: { show: true },
      axisTicks: { show: true },
    },
    yaxis: {
      show: false,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    grid: {
      borderColor: "#e7e7e7",
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => {
          return `<span style="display: flex; align-items: center;">
            <span style="margin-left: 5px;">${val}</span>
          </span>`;
        },
      },
    },
    colors: ["#5A9FFA"],
  });

  const [chartSeries, setChartSeries] = useState([
    {
      name: "Lead Count",
      data: [],
    },
  ]);

  const [creditSpend, setCreditSpend] = useState(0);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalTransactions, setTotalTransactions] = useState(0);

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      console.error("User ID not found in local storage.");
      return;
    }

    try {
      const response = await fetch(
        "https://apicanada.blaccdot.com/lead/all-monthly-lead-counts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_id: parseInt(userId, 10) }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        const { month, leadcount, creditspend, dleadcount, tottranscount } =
          result.data;

        setChartOptions((prevOptions) => ({
          ...prevOptions,
          xaxis: {
            ...prevOptions.xaxis,
            categories: month,
          },
        }));

        setChartSeries([
          {
            name: "Lead Count",
            data: leadcount,
          },
        ]);

        setCreditSpend(creditspend);
        setTotalLeads(dleadcount);
        setTotalTransactions(tottranscount);
      } else {
        console.error("Failed to fetch chart data.");
      }
    } catch (error) {
      console.error("Error while fetching chart data:", error);
    }
  };

  const handleDateChange = async (date, dateString) => {
    const userId = localStorage.getItem("userId");
  
    if (!date) {
      // If the date is cleared, reset the data to the original state or fetch the original data
      fetchChartData(); // Fetch the original data
      return;
    }
  
    const month = date.month() + 1; // Months are 0-indexed in moment.js
    const year = date.year();
  
    try {
      const response = await fetch(
        "https://apicanada.blaccdot.com/lead/specific-monthly-lead-counts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: parseInt(userId, 10),
            month: month,
            year: year,
          }),
        }
      );
  
      if (response.ok) {
        const result = await response.json();
        const { creditspend, dleadcount, tottranscount } = result.data;
  
        setCreditSpend(creditspend);
        setTotalLeads(dleadcount);
        setTotalTransactions(tottranscount);
      } else {
        console.error("Failed to fetch specific monthly lead counts.");
      }
    } catch (error) {
      console.error("Error while fetching specific monthly lead counts:", error);
    }
  };

  return (
    <Card
      title="Monthly Chart"
      extra={
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <DatePicker
            size="small"
            picker="month"
            onChange={handleDateChange}
          />
        </div>
      }
      style={{ width: "100%" }}
    >
      <div style={{ marginBottom: "20px" }}>
        <Row>
          <Col md={9}>
            <Chart options={chartOptions} series={chartSeries} type="bar" height={350} />
          </Col>
          <Col md={3}>
            <div>
              <span style={{ fontSize: "medium", color: "#898989", marginBottom: "5px" }}>
                Total Credit
              </span>
              <h4 style={{ fontWeight: "bold" }}>
                <GoStack style={{ fontSize: "20px", marginBottom: "5px", marginRight: "5px" }} />
                {creditSpend}
              </h4>
            </div>
            <div className="mt-4">
              <span style={{ fontSize: "medium", color: "#898989", marginBottom: "5px" }}>
                Total Leads
              </span>
              <h4 style={{ fontWeight: "bold" }}>
                <IoPersonOutline style={{ fontSize: "20px", marginBottom: "5px", marginRight: "5px" }} />
                {totalLeads}
              </h4>
            </div>
            <div className="mt-4">
              <span style={{ fontSize: "medium", color: "#898989", marginBottom: "5px" }}>
                Total Transactions
              </span>
              <h4 style={{ fontWeight: "bold" }}>
                <GrTransaction style={{fontSize: "20px", marginBottom: "5px",marginRight: "5px",color: "#515151"}}/>
                {totalTransactions}
              </h4>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default WeeklyChartBusiness;

// import React from "react";
// import { Card, DatePicker } from "antd";
// import { PiDotsThreeBold } from "react-icons/pi";
// import Chart from "react-apexcharts";
// import {Row,Col} from 'react-bootstrap'
// import { IoPersonOutline } from "react-icons/io5";
// import { CiDollar } from "react-icons/ci";
// import { PiTicketLight } from "react-icons/pi";
// import { GoStack } from "react-icons/go";
// import { GrTransaction } from "react-icons/gr";

// const WeeklyChartBusiness = () => {
//   // Updated Chart Options


//   const chartOptions = {
//     chart: {
//       type: "bar",
//       toolbar: { show: true },
//     },
//     plotOptions: {
//       bar: {
//         columnWidth: "60%",
//         dataLabels: { position: "top" },
//       },
//     },
//     dataLabels: {
//       enabled: true,
//       formatter: (val) => `${val}`, // Displays dollar value
//       offsetY: -20,
//       style: {
//         fontSize: "12px",
//         colors: ["#304758"],
//       },
//     },
//     xaxis: {
//       categories: [
//         "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//         "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
//       ],
//       position: "bottom",
//       labels: { style: { fontSize: "12px" } },
//       axisBorder: { show: true },
//       axisTicks: { show: true },
//     },
//     yaxis: {
//       show: false, // Hides the entire Y-axis
//       labels: { show: false }, // Hides Y-axis labels
//       axisBorder: { show: false }, // Hides Y-axis border
//       axisTicks: { show: false }, // Hides Y-axis ticks
//     },
//     grid: {
//       borderColor: "#e7e7e7",
//     },
//     tooltip: {
//       enabled: true,
//       y: {
//         formatter: (val) => {
//           return `<span style="display: flex; align-items: center;">
//           <span style="margin-left: 5px;">${val}</span>
//         </span>`;
        
//         }
//       },
//     },
//     colors: ["#5A9FFA"], // Bar color
//   };
//   // Updated Chart Data (representing dollar amounts)
//   const chartSeries = [
//     {
//       name: "Credit spent",
//       data: [2330, 3120, 4002, 5102, 4020, 3620, 3202, 2320, 1430, 8220, 5220, 2011],
//     },
//   ];

//   return (
//     <Card
//       title="Monthly Chart"
//       extra={
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <DatePicker size="small"  picker="year"  />
//           <PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />
//         </div>}  style={{ width: "100%" }}>
//       <div style={{ marginBottom: "20px" }}>
//         <Row>
//             <Col md={9}>
//             <Chart options={chartOptions} series={chartSeries} type="bar" height={350} />

//             </Col>
//             <Col md={3}>
//               <div>
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Credit spend</span>
//                 <h4 style={{fontWeigth:'bold'}}><GoStack style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px'}} />
//                 267.77</h4>
//               </div>
//               <div className="mt-4">
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Total leads</span>
//                 <h4 style={{fontWeigth:'bold'}}><IoPersonOutline style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px'}}/> 
//                 54,363</h4>
//               </div>
//               <div className="mt-4">
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Credit Rised</span>
//                 <h4 style={{fontWeigth:'bold'}}><PiTicketLight style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px'}}/> 
//                 03</h4>
//               </div>
//               <div className="mt-4">
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Total transaction</span>
//                 <h4 style={{fontWeigth:'bold'}}><GrTransaction style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px',color:"#515151"}}/> 
//                 03</h4>
//               </div>
//             </Col>
//         </Row>
//       </div>
//     </Card>
//   );
// };

// export default WeeklyChartBusiness;







// import React from "react";
// import { Card, DatePicker } from "antd";
// import { PiDotsThreeBold } from "react-icons/pi";
// import Chart from "react-apexcharts";
// import {Row,Col} from 'react-bootstrap'
// import { IoPersonOutline } from "react-icons/io5";
// import { CiDollar } from "react-icons/ci";
// import { PiTicketLight } from "react-icons/pi";
// import { GoStack } from "react-icons/go";
// import { GrTransaction } from "react-icons/gr";

// const WeeklyChartBusiness = () => {
//   // Updated Chart Options


//   const chartOptions = {
//     chart: {
//       type: "bar",
//       toolbar: { show: true },
//     },
//     plotOptions: {
//       bar: {
//         columnWidth: "60%",
//         dataLabels: { position: "top" },
//       },
//     },
//     dataLabels: {
//       enabled: true,
//       formatter: (val) => `${val}`, // Displays dollar value
//       offsetY: -20,
//       style: {
//         fontSize: "12px",
//         colors: ["#304758"],
//       },
//     },
//     xaxis: {
//       categories: [
//         "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//         "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
//       ],
//       position: "bottom",
//       labels: { style: { fontSize: "12px" } },
//       axisBorder: { show: true },
//       axisTicks: { show: true },
//     },
//     yaxis: {
//       show: false, // Hides the entire Y-axis
//       labels: { show: false }, // Hides Y-axis labels
//       axisBorder: { show: false }, // Hides Y-axis border
//       axisTicks: { show: false }, // Hides Y-axis ticks
//     },
//     grid: {
//       borderColor: "#e7e7e7",
//     },
//     tooltip: {
//       enabled: true,
//       y: {
//         formatter: (val) => {
//           return `<span style="display: flex; align-items: center;">
//           <svg version="1.1" id="fi_54637"  xmlns="http://www.w3.org/2000/svg" 
//             xmlns:xlink="http://www.w3.org/1999/xlink"   x="0px" 
//             y="0px" width="16px"  height="16px" viewBox="0 0 612 612" 
//             style="fill: #6c757d; vertical-align: middle;" xml:space="preserve">
//             <g>
//               <g id="_x32__21_">
//                 <g>
//                   <path d="M306,561.072L40.793,438.806C41.711,439.36,17.327,428.345,0,418.438c0,14.784,3.71,41.884,17.5,49.189l259.641,116.72
//                     c22.95,10.825,32.837,10.825,57.7,0l259.641-116.72C607.314,461.66,612,433.565,612,418.438
//                     c-16.696,8.357-40.335,20.272-40.794,20.368L306,561.072z M306,51.639C307.912,53.877,307.415,52.098,306,51.639L306,51.639z
//                      M17.5,345.361l259.641,116.72c22.95,10.824,32.837,10.824,57.7,0l259.641-116.72C607.314,339.394,612,311.3,612,296.171
//                     c-16.696,8.358-40.335,20.273-40.794,20.369L306,438.806L40.793,316.54c0.918,0.555-23.466-10.462-40.793-20.369
//                     C0,310.955,3.71,338.056,17.5,345.361z M17.5,223.095l259.641,116.72c22.95,10.825,32.837,10.825,57.7,0l259.641-116.72
//                     c19.125-8.912,19.756-46.818,0-57.643L334.841,28.364c-20.388-12.087-34.75-11.456-57.701,0L17.5,165.452
//                     C-2.257,178.189-2.888,212.27,17.5,223.095z M306,51.639l265.206,142.634L306,306.04L40.793,194.273L306,51.639z"></path>
//                 </g>
//               </g>
//             </g>
//           </svg>
//           <span style="margin-left: 5px;">${val}</span>
//         </span>`;
        
//         }
//       },
//     },
//     colors: ["#5A9FFA"], // Bar color
//   };
//   // Updated Chart Data (representing dollar amounts)
//   const chartSeries = [
//     {
//       name: "Credit spent",
//       data: [2330, 3120, 4002, 5102, 4020, 3620, 3202, 2320, 1430, 8220, 5220, 2011],
//     },
//   ];

//   return (
//     <Card
//       title="Monthly Chart"
//       extra={
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <DatePicker size="small"  picker="year"  />
//           <PiDotsThreeBold size={20} style={{ cursor: "pointer" }} />
//         </div>}  style={{ width: "100%" }}>
//       <div style={{ marginBottom: "20px" }}>
//         <Row>
//             <Col md={9}>
//             <Chart options={chartOptions} series={chartSeries} type="bar" height={350} />

//             </Col>
//             <Col md={3}>
//               <div>
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Credit spend</span>
//                 <h4 style={{fontWeigth:'bold'}}><GoStack style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px'}} />
//                 267.77</h4>
//               </div>
//               <div className="mt-4">
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Total leads</span>
//                 <h4 style={{fontWeigth:'bold'}}><IoPersonOutline style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px'}}/> 
//                 54,363</h4>
//               </div>
//               <div className="mt-4">
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Credit Rised</span>
//                 <h4 style={{fontWeigth:'bold'}}><PiTicketLight style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px'}}/> 
//                 03</h4>
//               </div>
//               <div className="mt-4">
//                 <span style={{fontSize: 'medium',color:'#898989',marginBottom:'5px'}}>Total transaction</span>
//                 <h4 style={{fontWeigth:'bold'}}><GrTransaction style={{fontSize:'20px',marginBottom:'5px',marginRight:'5px',color:"#515151"}}/> 
//                 03</h4>
//               </div>
//             </Col>
//         </Row>
//       </div>
//     </Card>
//   );
// };

// export default WeeklyChartBusiness;
